import { colors } from 'src/constants';
import { hTractionLogoWithText } from 'src/assets/images';

import { BulbIcon, CheckMarkIcon, ErrorIcon } from '../common.icons';

export const icon = {
  success: <CheckMarkIcon />,
  error: <ErrorIcon />,
  newIdea: <BulbIcon color={colors.primary[600]} />,
  confirm: hTractionLogoWithText
};
